// @flow
import eshopOrderClick from 'fg-frontend/webActions/eshopOrderClick';
import eshopComparisonShowDifferentLines from 'fg-frontend/webActions/eshopComparisonShowDifferentLines';
import eshopUserToolsHandle from 'fg-frontend/webActions/eshopUserToolsHandle';
import eshopUserToolsRefresh from 'fg-frontend/webActions/eshopUserToolsRefresh';

export default (action) => {
	switch (action) {
		case 'eshopUserToolsRefresh':
			return eshopUserToolsRefresh;
		case 'eshopOrderClick':
			return eshopOrderClick;
		case 'eshopComparisonShowDifferentLines':
			return eshopComparisonShowDifferentLines;
		case 'eshopUserToolsHandle':
			return eshopUserToolsHandle;
	}
};



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/configureEshopActions.js